import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'primereact/button';
import { FiSearch } from "react-icons/fi";

//NEW
import AuthContext from  "../../context/AuthContext";
import { useSelector, useDispatch } from "react-redux";
import { ReportDownloadByCategoryHorizontal } from 'services/report/report.service';
import { GetPermissions } from 'services/user/user.service';
import { Table } from 'components/Table/Table';
import { TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';

const ReportByCategoriesVsCompany = () => {

    const { reportListByCategoryHorizontal, reportListByCategoryHorizontalLoading } = useSelector((state) => state.reportListByCategoryHorizontal);

    const [showForm, setShowForm] = useState(false); //* state for form modal

    // Get FrontEndPermission
    const { permissionList } = useSelector((state) => state.permissionList);
    const { user } = useContext(AuthContext);

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(ReportDownloadByCategoryHorizontal());
        dispatch(GetPermissions());
    }, [user, ])

    // columns of the table with header name
    const generatedTableColumns = (data)=>{
        const keys = Object.keys(data)
        return keys.map(key => ({
            field: key,
            header: key,
            sortableBody: TextColumn,
            frozen: key === 'Category' ? true : false,
        }))
    }


    if(reportListByCategoryHorizontal?.[0]){
        var customHorizontalColumns = generatedTableColumns(reportListByCategoryHorizontal?.[0])
    }

    return (
        <>
            <Table
                tableHeaderName="Report By Category Vs Company"
                tableColumns={customHorizontalColumns}
                data={reportListByCategoryHorizontal}
                loading={reportListByCategoryHorizontalLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                scrollable
                scrollHeight = '700px'
                toolbarPermissions={permissionList[0]}
                exportBtn
                hideLeftToolbar
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                setShowCreateModal={setShowForm}

            />
        </>
    );
};

export default ReportByCategoriesVsCompany;
